import React from 'react';
import { motion } from 'framer-motion';
const testimonials = ['Arranqué con lo que tenía y vendí en la primera semana', 'Los packs me hicieron vender mucho más fácil', 'Ahora sé cuánto gano en cada producto', 'Dejé de cocinar sin sentido… ahora vendo con estrategia'];
export function SocialProof() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-196">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-197">
            <span className="text-brown-dark" data-id="element-198">Esto ya le está</span>{' '}
            <span className="text-olive" data-id="element-199">funcionando</span>{' '}
            <span className="text-brown-dark" data-id="element-200">a otras personas</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brown" data-id="element-201">
            Personas comunes, desde su casa, ya están vendiendo meriendas
            congeladas con este sistema.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-202">
          {testimonials.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-beige-dark/30 p-6 rounded-2xl border border-beige-dark flex items-start gap-4" data-id="element-203">
              <div className="flex-shrink-0 bg-olive text-white p-1 rounded-full mt-1" data-id="element-204">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-205">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" data-id="element-206"></path>
                </svg>
              </div>
              <p className="text-brown-dark font-medium text-lg italic" data-id="element-207">
                "{text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}